import { combineReducers } from 'redux';
import settings from './settings/reducer';
import landings from './landings/reducer';
import musicLinks from './musicLinks/reducer';
import musicLinkPages from './musicLinkPages/reducer';
import linkLandingPages from './linkLandingPages/reducer';
import premadeColors from './premadeColors/reducer';
import releases from './releases/reducer';
import artists from './artists/reducer';
import labels from './labels/reducer';
import profile from './profile/reducer';
import branding from './branding/reducer';
import trackMetadata from './trackMetadata/reducer';
import ddexStores from './ddexStores/reducer';
import tracks from './tracks/reducer';
import featureRequests from './featureRequests/reducer';
import accountingReports from './accountingReports/reducer';

const reducers = combineReducers({
    settings,
    landings,
    musicLinks,
    musicLinkPages,
    linkLandingPages,
    premadeColors,
    releases,
    artists,
    labels,
    profile,
    branding,
    trackMetadata,
    ddexStores,
    tracks,
    featureRequests,
    accountingReports,
});

export default reducers;
